var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"project-member-list"},[_c('a-row',[_c('a-col',{attrs:{"span":12}},[_c('project-members-overview',{attrs:{"can-edit":_vm.canEdit}})],1),_c('a-col',{attrs:{"span":12}},[_c('project-solvers',{attrs:{"can-edit":_vm.canEdit}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }